module.exports = __webpack_public_path__ + "img/arrow_up_b.839343f2.svg";